import { KVPair, ListPage, Order, Sortable } from "../../models/types";
import { useLoggedUser } from "../../hooks/user";
import { TablePagination } from "../commons/table-pagination/table-pagination";
import { DataTable } from "../commons/data-table/data-table";
import { ORDER_COLUMNS } from "./columns";

interface Props {
  hidePagination?: boolean;
  page: ListPage<Order>;
  loadPage: (
    page: number,
    pageSize?: number,
    filtering?: KVPair[],
    sorting?: string[]
  ) => void;
  onSelectOrder?: (order: Order) => void;
  onClick: (id: number) => void;
  sort?: (field: string) => void;
  sortInfo?: Sortable[];
}

export function OrderTable(props: Props) {
  const user = useLoggedUser({});

  return (
    <div>
      <DataTable
        columns={ORDER_COLUMNS}
        data={props.page.results}
        userRole={user?.role}
        sortInfo={props.sortInfo}
        onSort={props.sort}
        onRowClick={(order) => props.onClick(order.id)}
        onRowSelect={
          props.onSelectOrder
            ? (order) => props.onSelectOrder!(order)
            : undefined
        }
        getRowKey={(order) => order.id}
      />
      {!props.hidePagination && (
        <TablePagination page={props.page} loadPage={props.loadPage} />
      )}
    </div>
  );
}
